import Button from '@jbhi-fi/lanyard-ui/components/Button';
import React from 'react';
import { styles } from './SelectStoreButton.css';
import { Store } from '@jbhi-fi/lanyard-ui/components/Icons';

interface SelectStoreButtonProps {
  handleClick: () => void;
  variant?: 'hybrid';
}

export const SelectStoreButton = ({ handleClick, variant }: SelectStoreButtonProps) => {
  const isHybrid = variant === 'hybrid';
  return (
    <div className={isHybrid ? styles.hybrid : styles.actionButton} data-testid="result-select-store-button-wrapper">
      <Button
        type="secondary"
        onClick={handleClick}
        label="Set as your store"
        fullWidth={true}
        data-testid="result-select-store-button"
        icon={isHybrid ? <Store /> : undefined}
        iconPosition="left"
        classes={isHybrid ? styles.storeButton : ''}
      />
    </div>
  );
};
